import { render, staticRenderFns } from "./DataSourceTemplate.vue?vue&type=template&id=c871293c&scoped=true&"
import script from "./DataSourceTemplate.vue?vue&type=script&lang=ts&"
export * from "./DataSourceTemplate.vue?vue&type=script&lang=ts&"
import style0 from "./DataSourceTemplate.vue?vue&type=style&index=0&id=c871293c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c871293c",
  null
  
)

export default component.exports